import BaseComponent from '../base_component/base_component'
import VideoEventHandler from './video_event_handler'

export default class Video extends BaseComponent {

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
        
        this.$component = $(this.component);

        this.player = this.$component.find('video')
        this.initEventHandler(this.player);
    }

    initEventHandler() {
        this.eventHandler = new VideoEventHandler(this.player);
    }
}